import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-horizontal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "card-footer" }
const _hoisted_4 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_date_time_picker = _resolveComponent("app-date-time-picker")!
  const _component_app_image_holder = _resolveComponent("app-image-holder")!
  const _component_app_file_upload = _resolveComponent("app-file-upload")!
  const _component_app_simple_table = _resolveComponent("app-simple-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: (_ctx.model.cloneId ? 'Clone' : 'Create') + ' Promotion Item'
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        (_ctx.model.cloneId)
          ? (_openBlock(), _createBlock(_component_app_form_row, {
              key: 0,
              label: "For App"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_select, {
                  modelValue: _ctx.model.forAppId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.forAppId) = $event)),
                  modelModifiers: { number: true },
                  options: _ctx.appSelectOptions
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_app_form_row, { label: "Name" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.name) = $event)),
              validations: _ctx.v$.name
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Choose Display Type" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              modelValue: _ctx.model.displayType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.displayType) = $event)),
              modelModifiers: { number: true },
              options: _ctx.Options.DisplayType
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        (_ctx.model.displayType !== _ctx.DisplayType.AccessUnlimited.value)
          ? (_openBlock(), _createBlock(_component_app_form_row, {
              key: 1,
              label: "From Time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_date_time_picker, {
                  modelValue: _ctx.model.fromTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.fromTime) = $event)),
                  validations: _ctx.v$.fromTime
                }, null, 8, ["modelValue", "validations"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.model.displayType !== _ctx.DisplayType.AccessUnlimited.value)
          ? (_openBlock(), _createBlock(_component_app_form_row, {
              key: 2,
              label: "To Time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_date_time_picker, {
                  modelValue: _ctx.model.toTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.toTime) = $event)),
                  validations: _ctx.v$.toTime
                }, null, 8, ["modelValue", "validations"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_app_form_row, { label: "Expected Package" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.expectedPackage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.expectedPackage) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.expectedPackage
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Image" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_image_holder, {
              image: _ctx.model.image
            }, null, 8, ["image"]),
            _hoisted_2,
            _createVNode(_component_app_file_upload, {
              modelValue: _ctx.model.imageFile,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.imageFile) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, {
          label: "Prototype",
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              modelValue: _ctx.model.prototypeId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.prototypeId) = $event)),
              modelModifiers: { number: true },
              options: _ctx.model.prototypeOptions,
              validations: _ctx.v$.prototypeId
            }, null, 8, ["modelValue", "options", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_simple_table, {
          items: _ctx.model.personas,
          fields: ['rfmPersonaName', 'packageId', 'price', 'credit', 'rate']
        }, null, 8, ["items"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              icon: "fa-save",
              onClick: _withModifiers(_ctx.actions.create, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}